import type { CSSProperties } from "react";

export const backgroundColors = {
  cream: "#FFF0E1",
  white: "#FFFFFF",
  gray: "#989898",
  orange: "#FF9433",
  canvasBg: "#FFF7DD",
} as const;

/** Graded answer colours, matching ui-mobile's theme so a play looks the same on both apps. */
export const answerColors = {
  correct: "rgb(35,205,0)",
  wrong: "rgb(235,45,45)",
  correctSoft: "#d1fae5",
  wrongSoft: "#fee2e2",
} as const;

const centerFlex: CSSProperties = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

const boxShadow: CSSProperties = {
  boxShadow: "2px 4px 12px rgba(0, 0, 0, 0.2)",
};

const bigRadius: CSSProperties = {
  borderRadius: "15px",
};

export const cssClass: Record<string, CSSProperties> = {
  boxShadow,

  fontFamily: { fontFamily: "system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif" },

  bigFont: { fontSize: "1.8rem" },

  mediumFont: { fontSize: "1.3rem" },

  bigRadius,

  centerFlex,

  button: {
    boxShadow: "0 5px rgba(186, 186, 186, 0.9)",
    background: backgroundColors.white,
    ...bigRadius,
  },

  outerDiv: {
    position: "relative",
    padding: "3%",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    height: "100%",
    width: "100%",
    backgroundColor: backgroundColors.canvasBg,
  },

  textContainerBase: {
    width: "100%",
    height: "100%",
    overflow: "hidden",
    backgroundColor: backgroundColors.white,
    ...bigRadius,
    ...centerFlex,
    ...boxShadow,
  },

  choiceCard: {
    position: "relative",
    backgroundColor: backgroundColors.white,
    textAlign: "center",
    width: "33%",
    ...centerFlex,
    transition: "all 0.2s",
    cursor: "pointer",
    ...boxShadow,
  },
};
